import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { SearchResultSkeleton } from '../../../../common/ui/search-result-skeleton';

const resultsListGridAreaStyles = xcss({
	gridArea: 'results-list',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
});

export const Loading = (): React.JSX.Element => {
	return (
		<Box xcss={resultsListGridAreaStyles} testId="search-page-results-list">
			<SearchResultSkeleton />
			<SearchResultSkeleton />
			<SearchResultSkeleton />
			<SearchResultSkeleton />
		</Box>
	);
};
